<div class="node-creator">
  <div class="node-info-container">
    <gen-dynamic-form
            [formData]="data"
            (formChange)="nodeInfoChanged(data, $event.form)"
            [formName]="payload.config.nodeBuilder.nodeInfoForm"
            [editMode]="false"
            [disabled]="!isNameEditable()"
            [formVertical]="true"
            (validateChange)="updateNodeInfo($event)"
    ></gen-dynamic-form>
  </div>
  <div class="query-builder-container">
    <query-builder *ngIf="payload.config.nodeBuilder.queryBuilder"
                   [query]="data.ruleset"
                   [config]="payload.config.nodeBuilder.queryBuilder"
                   (validateChange)="updateQueryBuilder($event)">
    </query-builder>
  </div>
  <div class="node-content-actions" *ngIf="payload.config.nodeBuilder.actions">
    <div class="additional-actions">
      <gen-button *ngIf="payload.config.nodeBuilder.actions.guidingBox"
                  [ngClass]="[guideBoxVisible ? 'guided-box-visible' : '', payload.config.nodeBuilder.actions.guidingBox.cssClass]"
                  [type]="payload.config.nodeBuilder.actions.guidingBox.type"
                  [text]="payload.config.nodeBuilder.actions.guidingBox.text"
                  (click)="openGuidePopup()">
      </gen-button>
    </div>
    <div class="main-actions">
      <gen-button *ngIf="payload.config.nodeBuilder.actions.cancel"
                  [ngClass]="payload.config.nodeBuilder.actions.cancel.cssClass"
                  (click)="callback(undefined)"
                  [type]="payload.config.nodeBuilder.actions.cancel.type"
                  [text]="payload.config.nodeBuilder.actions.cancel.text"
                  [iconClass]="'icon__Cross2'"></gen-button>
      <gen-button [ngClass]="payload.config.nodeBuilder.actions.save.cssClass"
                  [disabled]="!nodeInfoValid || (!queryBuilderValid && payload.config.nodeBuilder.queryBuilder) || payload.readOnlyMode"
                  (click)="callback(data)"
                  [type]="payload.config.nodeBuilder.actions.save.type"
                  [text]="payload.config.nodeBuilder.actions.save.text"
                  [iconClass]="'icon__Checkmark2'"></gen-button>
    </div>
  </div>
</div>
